import { defineComponent as v, ref as i, computed as g, openBlock as r, createElementBlock as l, mergeProps as k, createTextVNode as B, toDisplayString as s, createCommentVNode as a, createElementVNode as f, normalizeClass as V, createVNode as w, unref as I } from "vue";
import { I as q } from "./IconAlertCircle-CRtSg4Nb.js";
const C = ["for"], N = {
  key: 0,
  class: "text-error ml-1"
}, T = { class: "relative" }, A = ["id", "type", "value", "placeholder", "disabled", "required", "autofocus"], E = {
  key: 0,
  class: "absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none"
}, F = {
  key: 1,
  class: "mt-2 text-sm text-error"
}, R = {
  key: 2,
  class: "mt-2 text-sm text-text-muted"
}, $ = /* @__PURE__ */ v({
  inheritAttrs: !1,
  __name: "Input",
  props: {
    modelValue: { default: "" },
    type: { default: "text" },
    label: { default: "" },
    placeholder: { default: "" },
    error: { default: "" },
    helpText: { default: "" },
    disabled: { type: Boolean, default: !1 },
    required: { type: Boolean, default: !1 },
    fullWidth: { type: Boolean, default: !0 },
    autofocus: { type: Boolean, default: !1 }
  },
  emits: ["update:modelValue", "blur", "focus"],
  setup(e, { expose: m, emit: b }) {
    const n = e, u = b, d = i(`input-${Math.random().toString(36).substr(2, 9)}`), o = i(null), h = (t) => {
      const c = t.target;
      u("update:modelValue", c.value);
    }, p = (t) => {
      u("blur", t);
    }, x = (t) => {
      u("focus", t);
    }, y = g(() => {
      const t = [
        "w-full",
        "px-4",
        "py-2.5",
        "text-text-main",
        "placeholder:text-text-disabled",
        "bg-bg-surface",
        "border",
        "rounded-input",
        "transition-all",
        "duration-200",
        "outline-none"
      ];
      return n.error ? t.push(
        "border-error",
        "text-error",
        "focus:border-error",
        "focus:ring-2",
        "focus:ring-error/10"
      ) : t.push(
        "border-border-subtle",
        "hover:border-border-hover",
        "focus:border-accent",
        "focus:ring-2",
        "focus:ring-accent/10"
      ), n.disabled && t.push("opacity-50", "cursor-not-allowed", "bg-bg-disabled"), t.join(" ");
    });
    return m({
      focus: () => {
        o.value?.focus();
      },
      blur: () => {
        o.value?.blur();
      },
      select: () => {
        o.value?.select();
      }
    }), (t, c) => (r(), l("div", k({
      class: ["input-wrapper", { "w-full": e.fullWidth }]
    }, t.$attrs), [
      e.label ? (r(), l("label", {
        key: 0,
        for: d.value,
        class: "block text-xs font-medium text-text-muted uppercase tracking-wide mb-1.5 ml-1"
      }, [
        B(s(e.label) + " ", 1),
        e.required ? (r(), l("span", N, "*")) : a("", !0)
      ], 8, C)) : a("", !0),
      f("div", T, [
        f("input", {
          ref_key: "inputRef",
          ref: o,
          id: d.value,
          type: e.type,
          value: e.modelValue,
          placeholder: e.placeholder,
          disabled: e.disabled,
          required: e.required,
          autofocus: e.autofocus,
          class: V(y.value),
          onInput: h,
          onBlur: p,
          onFocus: x
        }, null, 42, A),
        e.error ? (r(), l("div", E, [
          w(I(q), { class: "h-5 w-5 text-error" })
        ])) : a("", !0)
      ]),
      e.error ? (r(), l("p", F, s(e.error), 1)) : e.helpText ? (r(), l("p", R, s(e.helpText), 1)) : a("", !0)
    ], 16));
  }
});
export {
  $ as _
};
